import {LOCAL_STORAGE_KEYS} from "../utils/constants";
import {invokeApi} from "../bl_libs/invokeApi";

export const getAssessmentAdoption = async (org_code, schools, date_range) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/assessment/adoption',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        schools,
        date_range
    };
    return invokeApi(requestObj);
}

export const getAssessmentEfficacy = async (org_code, skill, schools, classes, date_range) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/assessment/efficacy',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        skill,
        schools,
        classes,
        date_range
    };
    return invokeApi(requestObj);
}

export const getEnhancementAdoptionSchool = async (org_code, schools, classes, date_range) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/enhancement/adoption/school',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        schools,
        classes,
        date_range
    };
    return invokeApi(requestObj);
}

export const getEnhancementAdoptionMonth = async (org_code, schools, classes, date_range) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/enhancement/adoption/month',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        schools,
        classes,
        date_range
    };
    return invokeApi(requestObj);
}

export const getEnhancementAdoptionModule = async (org_code, schools, classes, date_range) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/enhancement/adoption/module',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        schools,
        classes,
        date_range
    };
    return invokeApi(requestObj);
}

export const getEnhancementAdoptionGender = async (org_code, schools, classes, modules, date_range) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/enhancement/adoption/gender',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        schools,
        classes,
        modules,
        date_range
    };
    return invokeApi(requestObj);
}

export const getEnhancementAdoptionAge = async (org_code, schools, classes, modules, date_range) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/enhancement/adoption/age',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        schools,
        classes,
        modules,
        date_range
    };
    return invokeApi(requestObj);
}

export const getEnhancementAdoptionSchoolLevel = async (org_code, schools, classes, modules, date_range) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/enhancement/adoption/school_level',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        schools,
        classes,
        modules,
        date_range
    };
    return invokeApi(requestObj);
}

export const getEnhancementEfficacy = async (org_code, skill, schools, classes, date_range) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/enhancement/efficacy',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        skill,
        schools,
        classes,
        date_range
    };
    return invokeApi(requestObj);
}

export const getSchools = async (org_code, module_code, page_no, rows_per_page, order, order_by) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/progress/schools',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        module_code,
        page_no,
        rows_per_page,
        order,
        order_by
    };
    return invokeApi(requestObj);
}

export const getClasses = async (org_code, module_code, schools, page_no, rows_per_page, order, order_by) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/progress/classes',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        module_code,
        schools,
        page_no,
        rows_per_page,
        order,
        order_by
    };
    return invokeApi(requestObj);
}

export const getStudents = async (org_code, module_code, schools, classes, page_no, rows_per_page, order, order_by) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/progress/students',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        module_code,
        schools,
        classes,
        page_no,
        rows_per_page,
        order,
        order_by
    };
    return invokeApi(requestObj);
}

export const showImprovement = async (org_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/misc/show_improvement',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
    };
    return invokeApi(requestObj);
}

export const getSchoolRubricScoreService = async (org_code, module_code, institute_code, start_date, end_date, dist_keys) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/rubric/score',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        module_code,
        institute_code,
        start_date,
        end_date,
        dist_keys
    };
    return invokeApi(requestObj);
}

export const getSchoolParticipationScoreService = async (org_code, module_code, institute_code, start_date, end_date, dist_keys) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/participation/score',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        module_code,
        institute_code,
        start_date,
        end_date,
        dist_keys
    };
    return invokeApi(requestObj);
}

export const getUniqueModuleAssessL6CodesService = async (org_code, module_code, start_date, end_date) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/assessL6/codes',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        module_code,
        start_date,
        end_date,
    };
    return invokeApi(requestObj);
}

export const getModuleIndicatorTranslationsService = async (locale, module_codes, indicator_codes) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/module_indicator/translations',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        locale,
        module_codes,
        indicator_codes
    };
    return invokeApi(requestObj);
}

export const getScoresOverviewService = async (org_code, module_code, country, indicator_codes) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/scores_overview',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        module_code,
        country,
        indicator_codes
    };
    return invokeApi(requestObj);
}

export const getOverallEfficacyService = async (org_code, module_code, indicator_codes, start_date, end_date) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/overall_efficacy',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        module_code,
        indicator_codes,
        start_date,
        end_date
    };
    return invokeApi(requestObj);
}

export const getEfficacyBreakdownService = async (org_code, module_code, indicator_codes, start_date, end_date, postal_code_list) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/efficacy_breakdown',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        module_code,
        indicator_codes,
        start_date,
        end_date,
        postal_code_list
    };
    return invokeApi(requestObj);
}

export const getSchoolPerformanceService = async (org_code, module_code, start_date, end_date, dist_keys) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/school/performance',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        module_code,
        start_date,
        end_date,
        dist_keys
    };
    return invokeApi(requestObj);
}